import MaterialRow from "./material-row"
/**
 * @deprecated
 */
export default MaterialRow
